import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import { MAP_LAYER_IDS } from '../../../lib/constants';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import SketchViewModel from '@arcgis/core/widgets/Sketch/SketchViewModel';
import * as webMercatorUtils from '@arcgis/core/geometry/support/webMercatorUtils';

const EditFeature = (props) => {
  useEffect(() => {
    let graphicsLayer = new GraphicsLayer({
      id: MAP_LAYER_IDS.ghost,
      mode: 'on-the-ground',
    });

    graphicsLayer.screenSizePerspectiveEnabled = false;

    props.map.add(graphicsLayer);

    return function cleanup() {
      if (graphicsLayer && props.map) {
        props.map.remove(graphicsLayer);
      }
    };
  }, []);

  useEffect(() => {
    let sketchViewModel = null;

    props.view.when(() => {
      const graphicsLayer = props.map.findLayerById(MAP_LAYER_IDS.content);

      // Create a new instance of sketchViewModel
      sketchViewModel = new SketchViewModel({
        view: props.view,
        layer: graphicsLayer,
        updateOnGraphicClick: false,
        defaultUpdateOptions: {
          // set the default options for the update operations
          toggleToolOnClick: false, // only reshape operation will be enabled
        },
        // pointSymbol: {
        //   type: "simple-marker",
        //   style: "circle",
        //   size: 6,
        //   color: [255, 255, 255],
        //   outline: {
        //    color: [50, 50, 50],
        //     width: 1
        //   }
        // }
      });

      // Listen to sketchViewModel's update event to do
      // graphic reshape or move validation
      sketchViewModel.on(['update', 'undo', 'redo'], (e) => {
        const geometry = webMercatorUtils.webMercatorToGeographic(
          e.graphics[0].geometry
        );

        props.dispatch({
          type: 'map/updateWaypointLocation',
          payload: geometry,
        });
      });

      props.dispatch({
        type: 'map/setSketchModel',
        payload: sketchViewModel,
      });
    });

    return function cleanup() {
      if (sketchViewModel && sketchViewModel.destroy) {
        sketchViewModel.destroy();
      }
    };
  }, [props.view]);

  return null;
};

EditFeature.propTypes = {
  map: PropTypes.object,
  view: PropTypes.object,
};

export default connect(() => ({}))(EditFeature);
